/**
 * BrandLogo — flat 2D rendition matching the favicon exactly:
 * solid #002fa7 rounded square with white "PV" text.
 */
import React from "react";

export default function BrandLogo({ size = 48, className = "" }) {
  return (
    <div
      className={`inline-flex items-center justify-center bg-[#002fa7] text-white font-black select-none ${className}`}
      style={{
        width: size,
        height: size,
        borderRadius: size * 0.18,
        fontSize: size * 0.46,
        letterSpacing: "-0.04em",
        fontFamily: "Inter, system-ui, sans-serif",
      }}
      aria-label="Panchakosh Ventures"
    >
      PV
    </div>
  );
}
